import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen bg-[#F6F0E7] flex items-center justify-center text-[#697585]">
        Chargement…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" state={{ from: loc.pathname }} replace />;
  }
  return children;
}
